import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, PropertyDTO, OwnersApi, OwnerDocumentSearchParamsDto } from "@inosio/payments-sdk";
import { selectCurrentUser } from "../../../shared/sagas/auth/authSlice";
import { getOwnerDocuments, getOwnerDocumentsFailed, getOwnerProperties, getOwnerPropertiesFailed, setOwnerDocuments, setOwnerProperties } from "./documentsSlice";
import {IpaUserExtended} from "../../../shared/sagas/auth/authSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestGetOwnerProperties(access_token: string, ownerUUID: string) {
  apiConfig.accessToken = access_token;
  const ipaOwnerAPI = new OwnersApi(apiConfig);
  return ipaOwnerAPI.getOwnerProperties(ownerUUID);
}

export function requestGetOwnerDocuments(access_token: string, ownerUuid: string, ownerDocumentSearchParamsDto: OwnerDocumentSearchParamsDto) {
  apiConfig.accessToken = access_token;
  const ipaOwnerAPI = new OwnersApi(apiConfig);
  return ipaOwnerAPI.searchOwnerDocuments(ownerUuid, ownerDocumentSearchParamsDto);
}

export function* handleGetOwnerProperties(action: { type: typeof getOwnerProperties; payload: { ownerUuid: string } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PropertyDTO> = yield call(requestGetOwnerProperties, currentUser.accessToken, action.payload.ownerUuid);
    const { data } = response;

    yield put(setOwnerProperties(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getOwnerPropertiesFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getOwnerPropertiesFailed({ ...error }));
    }
  }
}

export function* handleGetOwnerDocuments(action: { type: typeof getOwnerDocuments; payload: { ownerUuid: string; ownerDocumentSearchParamsDto: OwnerDocumentSearchParamsDto } }) {
  try {
    const currentUser: IpaUserExtended = yield select(selectCurrentUser);
    const response: AxiosResponse<PropertyDTO> = yield call(requestGetOwnerDocuments, currentUser.accessToken, action.payload.ownerUuid, action.payload.ownerDocumentSearchParamsDto);
    const { data } = response;

    yield put(setOwnerDocuments(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(
        getOwnerDocumentsFailed({
          message: error?.response?.data?.message,
          statusCode: error?.response?.data?.statusCode,
        }),
      );
    } else {
      yield put(getOwnerDocumentsFailed({ ...error }));
    }
  }
}

export function* ownerDocumentsSaga() {
  yield takeLatest(getOwnerProperties.type, handleGetOwnerProperties);
  yield takeLatest(getOwnerDocuments.type, handleGetOwnerDocuments);
}
